import React, { useEffect, useState } from "react";
import { Divider, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { MENU_OPEN, SET_BREADCRUMBS } from "../../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { a11yProps, TabPanel } from "../../../utils/cssStyles";
import AssessmentIcon from "@mui/icons-material/Assessment";
// import ApprovePendingApiCampaings from "./ApprovePendingApiCampaigns";
// import ApprovePendingFlashCampaings from "./ApprovePendingFlashCampaigns";
import ApprovePendingBulkCampaings from "./ApprovePendingSmsCampaigns";
import { ConfigurationService } from "../../../assets/_services/configuration-service";

function ApprovePendingCampaings() {
  const theme: any = useTheme();
  const { state } = useLocation();
  const [paginationModel, setPaginationModel] = useState(state?.paginationModel);
  const [search, setSearch] = useState(state?.search);
  const [optOutMessage, setOptOutMessage] = useState<string>("");
  const [value, setValue] = useState(0);

  const path = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    window.history.replaceState({}, "");
    const id = path?.pathname;
    dispatch({ type: MENU_OPEN, id });
    dispatch({
      type: SET_BREADCRUMBS,
      payload: [
        { name: "Home", path: "/Dashboard", bold: true },
        { name: "Campaign Report", path: null, bold: false },
      ],
    });

    ConfigurationService.getOptOutMessage().then((response) => {
      if (response.isSuccess) {
        setOptOutMessage(response?.data?.data[0]?.value);
      }
    });
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPaginationModel(undefined);
    setSearch(undefined);
  };

  return (
    <Grid container justifyContent={"center"}>
      <Grid item xl={10} lg={8} md={7} xs={7}>
        <Stack justifyContent={"center"} height={"100%"}>
          <Divider textAlign="center">
            <Typography sx={{ ...theme.typography.pageheader }}>
              <AssessmentIcon fontSize="medium" /> Approve Pending Campaigns
            </Typography>
          </Divider>
        </Stack>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Tabs variant="scrollable" value={value} onChange={handleChange} aria-label="Vertical tabs example" sx={{ mb: 2 }}>
          {/* <Tab label="API Campaigns" {...a11yProps(0)} />
          <Tab label="Flash Campaigns" {...a11yProps(1)} /> */}
          <Tab label="Bulk Sms Campaigns" {...a11yProps(0)} />
        </Tabs>
        {/* <TabPanel value={value} index={0}>
          <ApprovePendingApiCampaings state={{ paginationModel, search }} value={value} />
        </TabPanel> */}
        {/* <TabPanel value={value} index={1}>
          <ApprovePendingFlashCampaings state={{ paginationModel, search }} value={value} />
        </TabPanel> */}
        <TabPanel value={value} index={0}>
          <ApprovePendingBulkCampaings state={{ paginationModel, search }} value={value} optOutMessage={optOutMessage} />
        </TabPanel>
      </Grid>
    </Grid>
  );
}

export default ApprovePendingCampaings;
